module.exports = __webpack_public_path__ + "static/media/pkm-niedz1.127c24e7.jpg";